/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_With_Skipper_TitleInputs */

const es_marketplace_seo_spain_guide_with_skipper_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler de barco con patrón`)
};

const gl_marketplace_seo_spain_guide_with_skipper_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiro de barco con patrón`)
};

const en_marketplace_seo_spain_guide_with_skipper_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat rental with skipper`)
};

/**
* | output |
* | --- |
* | "Boat rental with skipper" |
*
* @param {Marketplace_Seo_Spain_Guide_With_Skipper_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_with_skipper_title = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_With_Skipper_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_With_Skipper_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_with_skipper_title(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_with_skipper_title(inputs)
	return es_marketplace_seo_spain_guide_with_skipper_title(inputs)
});